module.exports = __webpack_public_path__ + "static/img/2.5a5ab19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/HeavyCopper/2.png
// module id = Q4Yi
// module chunks = 1